import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="toggler"
export default class extends Controller {
  static targets = ["button", "switch", "label"];

  connect() {
    // console.log(this.element);
  }

  // WIP: This is not working yet
  toggle() {
    this.buttonTarget.classList.toggle("bg-green-500/50");
    this.buttonTarget.classList.toggle("bg-stone-200");

    this.switchTarget.classList.toggle("translate-x-full");
    this.switchTarget.classList.toggle("translate-x-0");
    // this.buttonTarget.classList.toggle("flex-row");
    // this.buttonTarget.classList.toggle("flex-row-reverse");

    // this.labelTarget.textContent =
    //   this.labelTarget.textContent === "On" ? "On" : "Off";
  }
}
